import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

/**
 * @Author: 韩祺涛
 * @Date: 2023-01-06
 * @Project: 杭氧客户现场使用
 */

// 获取资产表格
export function getTableData (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/asset/list',
    // url: '/data/assetList.json',
    method: 'GET',
    params: parameter
  })
}
// 获取使用部门树
export function getDeptTreeList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/company/companyTree',
    // url: '/data/assetDept.json',
    method: 'GET',
    params: parameter
  })
}
// 获取档案树
export function getFileTreeList (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/dict/treequery',
    method: 'GET',
    params: parameter
  })
}